<template>
    <master-maintenance-list />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MasterMaintenanceList from '@/components/master/TypeList.vue';

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'master-maintenance-list': MasterMaintenanceList
    }
})
</script>
